import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from 'src/app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class UserModalService {

  private selectedUserSubject = new BehaviorSubject<User | null>(null);
  public selectedUser$ = this.selectedUserSubject.asObservable();

  constructor() { }

  setSelectedUser(user: User): void {
    this.selectedUserSubject.next(user);
  }

  getSelectedUser(): User | null {
    return this.selectedUserSubject.value;
  }

  clearSelectedUser(): void {
    this.selectedUserSubject.next(null);
  }
}
